module.exports = __webpack_public_path__ + "static/balsamiq.17b99dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/balsamiq.png
// module id = 717
// module chunks = 213534597649335